import { type Key, type ReactNode } from 'react';
import { useIntl } from 'react-intl';
import { Spinner } from '@repo/design-system-kit';
import { CheckoutHeader } from '@repo/domain-kit/invoices';
import styles from './checkout-pending.module.css';

interface CheckoutPendingProps {
  amount: string;
  organizationName: string;
  invoiceNumber: string;
  status: 'open' | 'paid';
  locales: { id: string; label: string }[];
  selectedLocale: string;
  onLocaleSelectionChange: (locale: Key) => void;
  isClientPortalEnabled?: boolean;
  children?: ReactNode;
}

export function CheckoutPending({
  amount,
  organizationName,
  invoiceNumber,
  status,
  locales,
  selectedLocale,
  onLocaleSelectionChange,
  isClientPortalEnabled,
  children,
}: CheckoutPendingProps): ReactNode {
  const { formatMessage } = useIntl();

  return (
    <div className={styles.container}>
      <div>
        <CheckoutHeader
          amount={amount}
          invoiceNumber={invoiceNumber}
          isClientPortalEnabled={isClientPortalEnabled}
          locales={locales}
          onLocaleSelectionChange={onLocaleSelectionChange}
          organizationName={organizationName}
          selectedLocale={selectedLocale}
          status={status}
        />
        {children}
      </div>
      <div className={styles.content}>
        <Spinner color="primary-a" size="large" />
        <h2 className="title-2" data-test-checkout-pending-title>
          {formatMessage({ id: 'invoice.success.processing' })}
        </h2>
      </div>
    </div>
  );
}
